<template>
  <popup-modal ref="popup">
    <DialogCloseButton :close-method="closeDialog" />

    <h2 class="font-weight-bold">
      {{ $t('FILE_STEP_GUARANTEE.EXCLUSION_GUARANTEE_MODAL.TITLE') }}
    </h2>
    <div class="my-8" style="text-align: start">
      <p class="text-pre-line">
        {{ message }}
      </p>
    </div>
    <div class="mx-auto">
      <v-btn class="boom-button modal-btn" variant="outlined" @click="_confirm">
        {{ $t('FILE_STEP_GUARANTEE.EXCLUSION_GUARANTEE_MODAL.BUTTON.VALID') }}
        <img
          alt="arrow_small-icon"
          class="arrow-svg"
          src="@/assets/icons/file/arrow_small_right.svg"
        />
      </v-btn>
    </div>
  </popup-modal>
</template>

<script>
import PopupModal from '../PopupModal.vue'
import DialogCloseButton from '@/components/modal/DialogCloseButton.vue'

export default {
  name: 'GuaranteeExclusionModal',
  components: { DialogCloseButton, PopupModal },
  data: () => ({
    message: undefined,
    resolvePromise: undefined,
    rejectPromise: undefined
  }),

  methods: {
    show(opts = {}) {
      this.message = opts.message
      this.$refs.popup.open()
      return new Promise((resolve, reject) => {
        this.resolvePromise = resolve
        this.rejectPromise = reject
      })
    },
    _confirm() {
      this.$refs.popup.close()
      this.resolvePromise({
        confirmed: true
      })
    },
    closeDialog() {
      this.$refs.popup.close()
    }
  }
}
</script>

<style scoped>
:deep(.v-selection-control__input > .v-icon) {
  color: #559a1b;
  opacity: unset;
}

:deep(.v-selection-control-group--inline) {
  margin: auto;
}

:deep(.logo-selector .v-field.v-field--appended) {
  justify-content: center !important;
  align-content: center;
}

:deep(.v-selection-control--inline .v-label) {
  opacity: unset;
}

.arrow-svg {
  height: 100%;
  width: 50%;
  filter: invert(89%) sepia(98%) saturate(1%) hue-rotate(266deg) brightness(110%) contrast(97%);
}

.modal-btn {
  display: flex;
  width: 220px;
  padding: 22px 40px;
  justify-content: center;
  align-items: center;
  gap: 15px;
}
</style>
